import ReinsuranceBanner from './ReinsuranceBanner';

export default ReinsuranceBanner;
